import "./icon.custom.objectPlace.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomObjectPlaceProps = ComponentProps<"svg">
function IconCustomObjectPlace(props: IconCustomObjectPlaceProps) {
  const { className, viewBox = "0 0 16 16", fill = "none", ...svgProps } = props

  return (
    <svg
      className={cn("objectPlace__svg", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        className="objectPlace__svg_main"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.33301C9.41449 1.33301 10.7713 1.89531 11.7715 2.89551C12.7716 3.89569 13.333 5.25258 13.333 6.66699C13.3327 10.6669 8 14.667 8 14.667C8 14.667 2.66727 10.6669 2.66699 6.66699C2.66699 5.25258 3.22842 3.89569 4.22852 2.89551C5.22871 1.89531 6.58551 1.33301 8 1.33301ZM8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5Z"
      />
    </svg>
  )
}

export default IconCustomObjectPlace
